import { Container } from "@brightagency/headstart-common";
import React from "react";
import { Outer, Inner, Title } from "./styled";

interface Props {
    title: string;
}

export const HeroPage: React.FC<Props> = props => {
    return (
        <Outer>
            <Container>
                <Inner>
                    <Title>{props.title}</Title>
                </Inner>
            </Container>
        </Outer>
    );
};
